import { render, staticRenderFns } from "./GeniePromotionalMediaManager.vue?vue&type=template&id=68d085dc&"
import script from "./GeniePromotionalMediaManager.vue?vue&type=script&lang=js&"
export * from "./GeniePromotionalMediaManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports